var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Image_02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0003 90.0004C15 89.6775 15 89.3445 15 89.001V31.001C15 25.4005 15 22.5981 16.0899 20.459C17.0487 18.5774 18.5774 17.0487 20.459 16.0899C22.5981 15 25.4005 15 31.001 15H89.001C94.6015 15 97.4003 15 99.5394 16.0899C101.421 17.0487 102.952 18.5774 103.911 20.459C105 22.596 105 25.395 105 30.9846V89.0155C105 91.4405 105 93.3395 104.911 94.887M15.0003 90.0004C15.0041 94.9421 15.0669 97.5291 16.0899 99.537C17.0487 101.419 18.5774 102.952 20.459 103.911C22.596 105 25.395 105 30.9846 105H89.0179C94.6075 105 97.4024 105 99.5394 103.911C101.421 102.952 102.952 101.419 103.911 99.537C104.528 98.3271 104.795 96.9064 104.911 94.887M15.0003 90.0004L38.8399 62.1875L38.8469 62.1798C40.9613 59.713 42.0203 58.4775 43.2764 58.0322C44.3797 57.6411 45.5843 57.6502 46.6821 58.0566C47.9332 58.5198 48.9753 59.7694 51.0596 62.2705L64.4154 78.2975C66.3448 80.6128 67.315 81.7771 68.4931 82.2444C69.5323 82.6566 70.6783 82.7031 71.7505 82.3866C72.971 82.0265 74.0454 80.9522 76.1938 78.8037L78.6792 76.3184C80.8667 74.1309 81.9604 73.0379 83.1984 72.6807C84.2857 72.3669 85.4482 72.4343 86.4941 72.8662C87.6851 73.358 88.651 74.5619 90.5835 76.9775L104.911 94.887M104.911 94.887L105 94.998M75 45C72.2386 45 70 42.7614 70 40C70 37.2386 72.2386 35 75 35C77.7614 35 80 37.2386 80 40C80 42.7614 77.7614 45 75 45Z",
    stroke: "#9A9A9A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage02);
export default __webpack_public_path__ + "static/media/Image_02.c1d7d03f35d1c94d615d9ac7ce298e07.svg";
export { ForwardRef as ReactComponent };